module.exports = __webpack_public_path__ + "img/logoData.6a56b116.png";